import Api from './api';

// Item 09 (16/10/2026) — sub-aba "Configuração de chatbot" do CRUD de LLM (copiloto de IA no editor de fluxo).
const PATH = '/llm-chatbot-settings';

const getByLLMId = async (llmId) => {
  try {
    const response = await Api.get(`${PATH}/${llmId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const update = async (llmId, payload) => {
  try {
    const response = await Api.put(`${PATH}/${llmId}`, payload);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const normalizeLLMChatbotSettings = (data) => ({
  flowBuilderEnabled: data?.flowbuilderenabled ?? data?.flowBuilderEnabled ?? false,
  additionalInstructions: data?.additionalinstructions ?? data?.additionalInstructions ?? "",
});

export {
  getByLLMId,
  update
};
